/**
 * The assistant screen's route literal: `./routes.ts` registers it and a
 * caller that links here imports the helper rather than spelling a second
 * literal. Relative to the router's `basepath`, like every other route in the
 * app.
 */

import { interpolatePath } from '@tanstack/react-router';

export const ASSISTANT_PATH = '/c/$campaignId/assistant';

/** `postId` scopes the link to that post's `?post=` -- 73-2-07's 'Perguntar
 *  sobre esta publicação' is the caller, so it never spells the param itself. */
export function assistantPath(campaignId: string, postId?: string): string {
  const path = interpolatePath({ path: ASSISTANT_PATH, params: { campaignId } }).interpolatedPath;
  return postId === undefined
    ? path
    : `${path}?${new URLSearchParams({ post: postId }).toString()}`;
}
